import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
/*
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider {
  constructor(public http: HttpClient) {}

  getSignedFileRequest(name) {
    return this.http.get(`${environment.apiUrl}/aws/files/${name}`);
  }

  deleteFile(name) {
    return this.http.delete(`${environment.apiUrl}/aws/files/${name}`);
  }

  getSignedUploadRequest(type) {
    return this.http.get(`${environment.apiUrl}/aws/sign?file-type=${type}`);
  }

  getData(url) {
    return this.http.get(`${environment.apiUrl}${url}`);
  }

  postData(url, data) {
    console.log(url, data);

    const headers = new HttpHeaders({
      "Content-type": "application/json"
    });

    return this.http.post(`${environment.apiUrl}${url}`, data, {
      headers: headers
    });
  }

  login(data) {
    const headers = new HttpHeaders({
      "Content-type": "application/json"
    });
  }

  getAssignment(agentEmail) {
    return this.http.get(
      `${environment.apiUrl}/assignments?agent=${agentEmail}`
    );
  }

  // getAgentByEmail(email) {
  //   return this.http.get(`${environment.apiUrl}/agents`);
  // }

  getMasterlist(sweep) {
    return this.http.get(
      `${environment.apiUrl}/products/masterlist?project=${sweep}`
    );
  }

  getSearchablelist(sweep) {
    return this.http.get(
      `${environment.apiUrl}/searchablelists?project=${sweep}`
    );
  }

  updateSearchablelist(id, searchablelistData) {
    return this.http.patch<Object>(
      `${environment.apiUrl}/searchablelists/${id}`,
      searchablelistData
    );
  }

  getCategories() {
    return this.http.get(`${environment.apiUrl}/categories`);
  }

  getProducts(projectId: string, retailerId: string) {
    return this.http.get(
      `${environment.apiUrl}/products?project=${projectId}&retailer=${retailerId}` //products?project=5df9b0004fd44952624bc1bd&status=ACTIVE
    );
  }

  getAgentProducts(agentId: string) {
    return this.http.get(`${environment.apiUrl}/products?agent=${agentId}`);
  }

  createProduct(productData) {
    return this.http.post<Object>(
      `${environment.apiUrl}/products`,
      productData
    );
  }

  createMasterlistProduct(masterlistData) {
    return this.http.post<Object>(
      `${environment.apiUrl}/masterlists`,
      masterlistData
    );
  }

  editProduct(id, productEditData) {
    return this.http.put<Object>(
      `${environment.apiUrl}/products/${id}`,
      productEditData
    );
  }

  uploadImage(formData) {
    return this.http.post<Object>(`${environment.apiUrl}/upload`, formData);
  }
}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts